<template>
    <job-layout key="post_job">
      <v-layout row wrap>
        <v-flex xs12>
          <app-name-page name="Post a Job" color="var(--green)"></app-name-page>
        </v-flex>
        <v-flex xs12>
          <v-container fill-height w--max--800 grid-list-xl>
            <app-job-form></app-job-form>
          </v-container>
        </v-flex>
      </v-layout>
    </job-layout>
  </template>
  
  <script>
  import AppJobForm from './components/job-form'
  import AppNamePage from '../../../components/app-name-page'
  import JobLayout from './job-layout'
  import { API_BASE_URL } from '../../../config/constants';

  
  export default {
    name: 'job-post',
    components: {
      JobLayout,
      AppNamePage,
      AppJobForm
    },
    mounted() {
      this.getAccountData();
    },
    methods: {
      async getAccountData() {
        try {
          const token = localStorage.getItem('_token'); 
  
          if (!token) {
            throw new Error('Token not found in localStorage under key "_token".');
          }
  
          const response = await fetch(`${API_BASE_URL}account`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`, 
            }
          });
  
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
  
          const data = await response.json();
          console.log('✅ Account Data:', data.subscription.ends_at);

          if (data.subscription.ends_at === null) {
      console.warn('⚠️ Subscription expired or missing, going back.');
      this.$router.go(-1); // Go back to previous page
      // OR use: this.$router.push('/') to go to home
    }
        } catch (error) {
          console.error('❌ Error fetching account data:', error);
        }
      }
    }
  }
  </script>
  
  <style lang="stylus" scoped>
  
  </style>
  


// WEBPACK FOOTER //
// src/views/app/jobs/job-post.vue